import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';

import { RedContext } from '../../../context/connection/ContextRed';
import { fetchConToken } from '../../../api/fetch';
import { useForm } from '../../../hooks/useForm';
import moment from 'moment';
import { useContextInfo } from '../../../context/ContextInfo';
import MapaRender from '../../map/MapaRender';
import { UserContext } from '../../../context/user/ContextUser';

const ServiceFibra = ({ install, onClose }) => {
    const [firewall_state, setfirewall_state] = useState(true);

    const { setResp } = useContextInfo();
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const [load, setLoad] = useState(false);
    const { usersState } = useContext(UserContext);
    const [showMp, setshoMp] = useState(false);

    const { redState, dispatchRed } = useContext(RedContext);
    const [mkIpv4, setMkIpv4] = useState([]);
    const [Ipv4, setIpv4] = useState([]);
    const [Ports, setPuertos] = useState([]);
    const [naps, setNap] = useState([]);
    const [onus, setOnus] = useState([]);
    const [ipAx, setIpAx] = useState('');
    const day = moment().format('YYYY-MM-DD');

    const [values, handleInputChange, setFormValue] = useForm({
        id_cliente: '',
        mknodo: '',
        olt: '',
        ser_tipo: 'FIBRA',
        redIpv4: '',
        idIpv4: '',
        ip: '',
        mac: '',
        id_tec: '0',
        coordenadas: '',
        instalado: day,
        idperfil: '',
        idnap: '',
        portnap: '',
        install: '',
    });
    const { mknodo, redIpv4, idnap, olt } = values;
    useEffect(() => {
        getIpv4();
    }, [mknodo]);
    useEffect(() => {
        getIp();
    }, [redIpv4]);
    useEffect(() => {
        getNaps();
    }, []);
    useEffect(() => {
        getPort();
    }, [idnap]);

    // !obtine los puertos del nap
    const getPort = async () => {
        const id = parseInt(idnap);
        if (id) {
            const res = await fetchConToken(`networks/napports/${id}/0`);
            if (res.ok) {
                setPuertos(res.data);
            }
        } else {
            setPuertos([]);
        }
    };
    //!obtine los ipv4 redes qu epertenecen al mktik
    const getIpv4 = async () => {
        if (mknodo) {
            const re = await fetchConToken(`networks/ipv4bymkt/${mknodo}`);

            if (re.ok) setMkIpv4(re.data);
        } else {
            setIpv4([]);
            setMkIpv4([]);
            setIpAx([]);
            setFormValue({ ...values, redIpv4: '', ip: '' });
        }
    };

    // !obtiene las ips del ipv4 red
    const getIp = async () => {
        if (redIpv4.length > 0) {
            const result = mkIpv4.find((red) => red.subred === redIpv4);
            setIpAx(result?.id);
            const res = await fetchConToken(`servis/ip/${values.redIpv4}/0`);
            if (res.ok) {
                setIpv4(res.data);
                setFormValue({ ...values, ip: res.data[0] });
            }
        } else {
            setIpv4([]);
            setFormValue({ ...values, redIpv4: '', ip: '' });
        }
    };
    const getNaps = async () => {
        const resu = await fetchConToken(`networks/naps`);
        if (resu.ok) {
            setNap(resu.data.naps);
            setOnus(resu.data.onus);
        }
    };
    const changeCoor = (coords) => {
        setFormValue({ ...values, coordenadas: coords });
    };

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);

        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            const data = {
                mknodo: values.mknodo,
                ser_tipo: values.ser_tipo,
                firewall_state,
                redIpv4: values.redIpv4,
                idIpv4: ipAx,
                ip: values.ip,
                mac: values.mac,
                id_tec: values.id_tec,

                coordenadas: values.coordenadas,
                instalado: values.instalado,
                zona: '',
            };
            const fibra = {
                id_speed: values.idperfil,
                id_olt: values.olt,
                id_nap: values.idnap,
                port_nap: values.portnap,
            };
            let method = 'POST';
            let url = 'usservis';
            if (install.type === 'NEW') {
                method = 'PUT';
                url = 'usservis/add';
            }
            const res = await fetchConToken(
                url,
                {
                    service: data,

                    type: fibra,
                    install,
                    carinst: values.install,
                },
                method
            );
            setResp(res);
            setLoad(false);

            if (res.ok) {
                onClose();
                const idre = res.regis;
                navigate(`/admin/viewuser/${btoa(`${idre}`)}`);
            }
        }
        setLoad(false);
    };
    return (
        <div>
            {' '}
            <>
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <Form noValidate validated={validated} onSubmit={onSubmit}>
                                    <Row>
                                        <Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom0">
                                                    <Form.Label>Router</Form.Label>
                                                    <Form.Select
                                                        value={values.mknodo}
                                                        name="mknodo"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="">Selecciona un Router </option>

                                                        {redState.mktiks.map((mk, i) => (
                                                            <option value={mk.id} key={i}>
                                                                {mk.nodo}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom0">
                                                    <Form.Label>Olt</Form.Label>
                                                    <Form.Select
                                                        value={values.olt}
                                                        name="olt"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="">Selecciona una olt </option>

                                                        {redState.olts.map((mk, i) => (
                                                            <option value={mk.id} key={i}>
                                                                {mk.nombre}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom0">
                                                    <Form.Label> Plan de internet</Form.Label>
                                                    <Form.Select
                                                        value={values.idperfil}
                                                        name="idperfil"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="">Seleccionar... </option>

                                                        {redState.planesfi.map((int, i) => (
                                                            <>
                                                                {!int.disabled && (
                                                                    <option value={int.id} key={i}>
                                                                        {int.nombre}
                                                                    </option>
                                                                )}
                                                            </>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom0">
                                                    <Form.Label> Redes IPv4</Form.Label>
                                                    <Form.Select
                                                        value={values.redIpv4}
                                                        name="redIpv4"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="">Seleccionar... </option>

                                                        {mkIpv4.map((iv) => (
                                                            <option value={iv.subred} key={iv.subred}>
                                                                {iv.subred} ( {iv.host - iv.us} Ips disponibles){' '}
                                                                {iv.nombre}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom0">
                                                    <Form.Label> IPv4</Form.Label>
                                                    <Form.Select
                                                        value={values.ip}
                                                        name="ip"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="">Seleccionar... </option>
                                                        {Ipv4.map((ip, i) => (
                                                            <option value={ip} key={i}>
                                                                {ip}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom1">
                                                    <Form.Label>Mac</Form.Label>
                                                    <MaskedInput
                                                        mask={[
                                                            /[A-Fa-f0-9]/,
                                                            /[A-Fa-f0-9]/,
                                                            ':',
                                                            /[A-Fa-f0-9]/,
                                                            /[A-Fa-f0-9]/,
                                                            ':',
                                                            /[A-Fa-f0-9]/,
                                                            /[A-Fa-f0-9]/,
                                                            ':',
                                                            /[A-Fa-f0-9]/,
                                                            /[A-Fa-f0-9]/,
                                                            ':',
                                                            /[A-Fa-f0-9]/,
                                                            /[A-Fa-f0-9]/,
                                                            ':',
                                                            /[A-Fa-f0-9]/,
                                                            /[A-Fa-f0-9]/,
                                                        ]}
                                                        required
                                                        type="text"
                                                        className="form-control text-uppercase"
                                                        name="mac"
                                                        onChange={handleInputChange}
                                                        value={values.mac}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                        </Col>
                                        <Col>
                                            {' '}
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom0">
                                                    <Form.Label> Técnico</Form.Label>
                                                    <Form.Select
                                                        value={values.id_tec}
                                                        name="id_tec"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="0">Sin asignar </option>

                                                        {usersState?.agentes
                                                            .filter(({ campo }) => campo === true)
                                                            .map(({ id_agent, name }) => (
                                                                <option value={id_agent} key={id_agent}>
                                                                    {name}
                                                                </option>
                                                            ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom0">
                                                    <Form.Label>Caja NAp</Form.Label>
                                                    <Form.Select
                                                        value={values.idnap}
                                                        name="idnap"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="">Ninguno </option>

                                                        {naps
                                                            .filter(({ id_olt }) => id_olt === parseInt(values.olt))
                                                            .map((na) => (
                                                                <option value={na.id} key={na.id}>
                                                                    {na.descripcion} {`(`}
                                                                    {na.puertos - na.used}
                                                                    {`)`} disponibles
                                                                </option>
                                                            ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Row>
                                                    <Col>
                                                        {' '}
                                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                                            <Form.Label> Puerto Nap</Form.Label>
                                                            <Form.Select
                                                                value={values.portnap}
                                                                name="portnap"
                                                                required
                                                                onChange={handleInputChange}>
                                                                <option value="">Ninguno </option>
                                                                {Ports.map((na) => (
                                                                    <option value={na} key={na}>
                                                                        Puerto {na}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom08">
                                                    <Form.Label>Coordenadas</Form.Label>
                                                    <InputGroup>
                                                        <InputGroup.Text
                                                            id="inputGroupPrepend"
                                                            onClick={() => setshoMp(!showMp)}>
                                                            <i className="mdi mdi-map-marker-radius" />
                                                        </InputGroup.Text>
                                                        <Form.Control
                                                            type="text"
                                                            value={values.coordenadas}
                                                            name="coordenadas"
                                                            onChange={handleInputChange}
                                                        />
                                                    </InputGroup>
                                                </Form.Group>{' '}
                                            </Col>{' '}
                                            <Col>
                                                <Row>
                                                    {' '}
                                                    <Col>
                                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                                            <Form.Label>Costo de instalación</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="number"
                                                                value={values.install}
                                                                name="install"
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                        </Form.Group>{' '}
                                                    </Col>
                                                    <Col>
                                                        {' '}
                                                        <Form.Group className="mt-4" controlId="validationCustom0999">
                                                            <Form.Check
                                                                checked={firewall_state}
                                                                onChange={() => setfirewall_state(!firewall_state)}
                                                                type="switch"
                                                                label="Excluir firewall"
                                                                className="mt-1"
                                                            />{' '}
                                                        </Form.Group>
                                                    </Col>{' '}
                                                </Row>
                                            </Col>
                                        </Col>
                                    </Row>{' '}
                                    {load ? (
                                        <Button color="primary" disabled>
                                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                            Guardando...
                                        </Button>
                                    ) : (
                                        <Button type="submit">Guardar</Button>
                                    )}
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </>
            <MapaRender show={showMp} onClose={() => setshoMp(false)} legend="Emisor" marks={[]} setCoor={changeCoor} />
        </div>
    );
};

export default ServiceFibra;
